import React from 'react';
import PropTypes from 'prop-types';
import Amount from 'sharedWebpack/Amount';
import './styles.scss';

const ExchangePenalty = ({ priceDetails }) => {
  const { currency, amount } = priceDetails;

  return (
    <div className="exchange-penalty__container">
      <div className="exchange-penalty__content d-flex align-center justify-between">
        <div>{I18n.t('components.ibe.exchange.cart.penalty')}</div>
        <Amount className="exchange-cart-summary__amount" currency={currency} value={amount} />
      </div>
    </div>
  );
};

ExchangePenalty.propTypes = {
  priceDetails: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    amount: PropTypes.string.isRequired,
  }).isRequired,
};

export default ExchangePenalty;
